const ValidationError = function create(fieldName, objectId, message) {
  if (Array.isArray(fieldName)) {
    this.errors = fieldName.map(singleFieldName => ({ path: singleFieldName, objectId, message }));
  } else {
    this.errors = [{ path: fieldName, objectId, message }];
  }

  this.message = message;
  this.name = 'ValidationError';
};

const ValidationWarning = function create(message, overrideVariable) {
  this.message = message;
  this.overrideVariable = overrideVariable;
  this.name = 'ValidationWarning';
};

const AggregateError = function create(errors) {
  this.name = 'AggregateError';
  const messages = errors.map(e => e.message);
  this.message = messages.join('\n');
  this.errors = errors;
};

const NotFoundError = function create(msg) {
  this.message = msg;
  this.name = 'NotFoundError';
};

const NotAuthenticatedError = function create(msg) {
  this.message = msg;
  this.name = 'NotAuthenticatedError';
};

const NotAuthorizedError = function create(msg) {
  this.message = msg;
  this.name = 'NotAuthorizedError';
};

const NoSessionError = function create() {
  this.name = 'NoSessionError';
  this.message = 'The session has expired, re-authentication required.';
};

const ConfigurationError = function create(msg) {
  this.message = msg;
  this.name = 'ConfigurationError';
};

const ConcurrencyError = function create(msg, entityId, updatedAt, updatedBy, oldEntity) {
  this.message = msg;
  this.entityId = entityId;
  this.updatedAt = updatedAt;
  this.updatedBy = updatedBy;
  this.oldEntity = oldEntity;
  this.name = 'ConcurrencyError';
};

const ConnectionError = function create(msg) {
  this.message = msg;
  this.name = 'ConnectionError';
};

function PermissionError() {}
Object.setPrototypeOf(PermissionError, Error);
PermissionError.prototype = Object.create(Error.prototype);
PermissionError.prototype.name = 'PermissionError';
PermissionError.prototype.message = '';
PermissionError.prototype.constructor = PermissionError;

module.exports = {
  AggregateError,
  ConcurrencyError,
  ConfigurationError,
  ConnectionError,
  NoSessionError,
  NotAuthenticatedError,
  NotAuthorizedError,
  NotFoundError,
  PermissionError,
  ValidationError,
  ValidationWarning,
};
